module.exports = __webpack_public_path__ + "img/parcel.f91895bf.jpg";